/**
 * Courier services list and auto-tracking URL builder
 * Used in JobDetail (staff adds) and TrackJob (customer views)
 */

export const COURIER_SERVICES = [
  "Delhivery",
  "BlueDart",
  "DTDC",
  "FedEx",
  "DHL",
  "Ekart Logistics",
  "Ecom Express",
  "Shadowfax",
  "Xpressbees",
  "Amazon Logistics",
  "India Post",
  "Shiprocket",
  "Other",
];

// Auto-generate tracking URL for each courier based on AWB number
export const buildTrackingUrl = (courierName, awb) => {
  if (!awb || !courierName) return "";
  const w = awb.trim();
  switch (courierName) {
    case "Delhivery":
      return `https://www.delhivery.com/tracking/${w}`;
    case "BlueDart":
      return `https://www.bluedart.com/web/guest/home?_Search_WAR_homepageportlet_waybillnumber=${w}`;
    case "DTDC":
      return `https://www.dtdc.in/tracking/cargo_track.asp?TrkType=awb&strCNno=${w}`;
    case "FedEx":
      return `https://www.fedex.com/apps/fedextrack/?tracknumbers=${w}`;
    case "DHL":
      return `https://www.dhl.com/in-en/home/tracking.html?tracking-id=${w}`;
    case "Ekart Logistics":
      return `https://ekartlogistics.com/track/${w}`;
    case "Ecom Express":
      return `https://ecomexpress.in/tracking/?awb_field=${w}`;
    case "Shadowfax":
      return `https://tracker.shadowfax.in/track/?tracking=${w}`;
    case "Xpressbees":
      return `https://www.xpressbees.com/track?trackingno=${w}`;
    case "Amazon Logistics":
      return `https://track.amazon.in/tracking/${w}`;
    case "India Post":
      return `https://www.indiapost.gov.in/VAS/Pages/ShipmentTracking.aspx?consignment=${w}`;
    default:
      return ""; // "Other" — staff enters manually
  }
};
